import React, { useEffect, useState } from "react";
import Account from "./Account";
import Organisation from "./Organisation";
import Tags from "./Tags";
import { Org, Workspace } from "../../types/org";
import { User } from "../../types/user";

// Components mapping
const components = {
  Account: Account,
  Organisation: Organisation,
  Tags: Tags,

  // Add other components like Notifications, Security, etc.
};

// Parameters Component
type ParametersProps = {
  page: keyof typeof components;
  userData: User | null; // Replace 'any' with the actual type if known
  orgData: Org | null; // Replace 'any' with the actual type if known
  navigateWorkspace: (...args: any[]) => void;
  overrideId?: string;
  workspaceData?: Workspace | null;
  masterData?: Org | null; // Optional prop for master data
};

function Parameters({
  page,
  userData,
  orgData,
  navigateWorkspace,
  overrideId,
  workspaceData,
  masterData,
}: ParametersProps) {
  const Component = components[page];

  // Check if Component exists before rendering
  if (!Component) {
    return <div>Page not found</div>;
  }
  if (!userData || !orgData) {
    return <div>Loading...</div>; // Handle loading state or error
  }
  return (
    <Component
      userData={userData as User}
      orgData={orgData}
      navigateWorkspace={navigateWorkspace}
      overrideId={overrideId}
      workspaceData={workspaceData ?? null}
      masterData={masterData ?? null}
    />
  );
}

export default Parameters;
